import { CheckoutSession } from '@/fairplayer/domain/CheckoutSession';

export interface BackendCheckoutSession {
  url: string;
}

export const toCheckoutSession = (backendCheckoutSession: BackendCheckoutSession): CheckoutSession => ({
  url: backendCheckoutSession.url,
});
